import * as React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

export default function BasicDatePicker({
  label,
  onChange,
  value,
  sx = {},
  style = {},
  required = false,
  maxDate,
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer
        sx={{
          marginTop: "-8px",
          width: "100%",
          "& .MuiTextField-root, & .MuiPickersTextField-root": {
            width: "100%",
          },
          "& .MuiFormLabel-root": {
            lineHeight: "0.4375em",
            overflow: "inherit",
          },
          "& .MuiInputBase-root": {
            textAlign: "left",
            minHeight: "40px",
            paddingRight: "40px !important",
          },
          "& .MuiInputAdornment-root": {
            position: "absolute",
            right: "15px", // Keep the icon aligned on smaller screens
            zIndex: 110,
          },
          "& .MuiInputLabel-shrink": {
            transform: "translate(14px, -3px) scale(0.85)",
          },
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
            color: "#3071FF",
            "@media (max-width: 650px)": {
              width: "20px",
              height: "20px",
            },
          },
          ...sx,
        }}
        components={["DatePicker"]}
      >
        <DatePicker
          format="DD/MM/YY"
          slotProps={{
            textField: {
              error: false,
              InputProps: {
                sx: {
                  paddingRight: "40px", // Ensure space for the icon
                },
                style: {
                  height: "40px",
                  overflow: "hidden",
                  backgroundColor: "#3071FF21",
                  boxSizing: "border-box",
                  ...style,
                },
              },
            },
          }}
          label={
            <span>
              {label} {required && <span>*</span>}
            </span>
          }
          placeholder="Select a date"
          onChange={onChange}
          value={value || null}
          {...(maxDate && { maxDate: dayjs() })}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}
